import { render, staticRenderFns } from "./SystemNotifications.vue?vue&type=template&id=3e994605&"
import script from "./SystemNotifications.vue?vue&type=script&lang=js&"
export * from "./SystemNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports